<template>
  <div>
    <v-container grid-list-xl fluid>
      <table-request></table-request>
    </v-container>
  </div>
</template>

<script>
import TableRequest from "@/components/table/TableRequest";

export default {
  name: "RequestsList",
  components: {
    TableRequest
  }
};
</script>

<style scoped></style>
